import React from 'react'

import { EditSelectedModel } from 'features/Agents/configuration/common/EditSelectedModel'
import { EditToolsControlled } from 'features/Agents/configuration/tools/EditTools'
import { OutputSchemaEditor } from 'features/workflows/OutputSchema/OutputSchemaEditor'
import { ConfigurationLabel } from 'features/workflows/WorkflowUI'

import { Select, SelectOption } from 'ui/components/Select'

import { WorkflowActionEditorComponent } from './types'

export const AIPromptActionConfig: WorkflowActionEditorComponent = ({ action, onChange }) => {
    const selectedModel = action.settings?.selected_model as string | undefined
    const configuredTools = action.settings?.configured_tools as any[] | undefined
    const outputSchema = action.settings?.output_schema as WorkflowOutputSchema | undefined
    const outputFormat = !!outputSchema ? 'json' : 'text'

    const handleChangeSettings = (patch: Record<string, unknown>) => {
        onChange({
            settings: {
                ...action.settings,
                ...patch,
            },
        })
    }

    const handleOutputFormatChange = (format: string) => {
        if (format === 'json') {
            handleChangeSettings({ output_schema: { schema: [] } })
        } else {
            handleChangeSettings({ output_schema: undefined })
        }
    }

    return (
        <>
            <ConfigurationLabel>Model</ConfigurationLabel>
            <EditSelectedModel
                label=""
                value={selectedModel}
                style={{ width: '100%' }}
                onChange={(value) => handleChangeSettings({ selected_model: value })}
            />
            <ConfigurationLabel>Output format</ConfigurationLabel>
            <Select value={outputFormat} onChange={handleOutputFormatChange} size="m">
                <SelectOption value="text" label="Text" />
                <SelectOption value="json" label="Structured (JSON)" />
            </Select>
            {outputFormat === 'json' && (
                <>
                    <ConfigurationLabel>Output schema</ConfigurationLabel>
                    <OutputSchemaEditor
                        value={outputSchema}
                        onChange={(value) => handleChangeSettings({ output_schema: value })}
                        mb="l"
                    />
                </>
            )}

            <ConfigurationLabel>Available Tools</ConfigurationLabel>
            <EditToolsControlled
                agentSid=""
                label=""
                tools={configuredTools || []}
                onChange={(tools) => handleChangeSettings({ configured_tools: tools })}
            />
        </>
    )
}
